import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../_services/auth.service';

export const aiBlueprintsGuard: CanActivateFn = (): boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAiBlueprintsEnabled) {
    return true;
  }

  return router.parseUrl('/home');
};
